<template>
  <div>
    <div class="steps">
      <div v-if="editable" class="addStep0">
          <button id="btn-add-step" class="glyphicon glyphicon-plus add" @click="events.addStep(0)"></button>
      </div>
      <div v-for="(step, index) in steps" class="step" :class="{'active': step.active}">
        <span v-if="icons" class="glyphicon icon" :class="{ 'glyphicon-ok': step.completed, 'glyphicon-cog': !step.completed && !step.active, 'glyphicon-refresh': step.active }"> </span>
        <span v-else style="font-size: 36px; margin-right: 10px;">{{index + 1}}.</span>
        <div class="content">
          <div v-if="editable">
            <input type="text" class="form-control field-name" v-model="step.name" placeholder="Nome"/>
            <input type="text" class="form-control field-description" v-model="step.description" placeholder="Descrição"/>
            <multiselect v-model="step.target" id="target" label="description" track-by="objectId" :options="groups" :showLabels=false placeholder="Selecione o grupo"></multiselect>
            <div v-if="step.objectId" class="message">
              Para selecionar o grupo dinamicamente, <router-link :to="{name: 'StepGroupRuleList', params: {stepId: step.objectId}}"> clique aqui</router-link>.
            </div>
            <div v-else class="message">
              Salve o passo antes para definir as regras de grupo.
            </div>
          </div>
          <div v-else>
            <p class="title">{{step.name}}</p>
            <div class="step-resume">
              <div v-if="step.description" class="step-description">{{ step.description }}</div>
              <div v-if="step.target"><label>Grupo Alvo:</label> <b>{{ step.target.description }}</b><span v-if="request && request.dynamicStepGroup && request.currentStep.objectId === step.objectId">, mas dinamicamente alocado para <b>{{request.dynamicStepGroup.description}}</b></span></div>
            </div>
          </div>
        </div>
        <div v-if="editable" class="step-options">
            <button class="glyphicon glyphicon-remove remove btn-remove-step" @click="events.removeStep(index)" title="Excluir passo"></button>
            <button class="glyphicon glyphicon-plus add" @click="events.addStep(index)" title="Adicionar passo"></button>
            <button class="glyphicon glyphicon-transfer add-trammit-fields" @click="events.addFieldsToTrammit(step)" title="Adicionar campos de Tramitação"></button>
            <button class="glyphicon glyphicon-expand add-evaluate-fields" @click="events.addExtraActions(step)" title="Adicionar Ações Extras"></button>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: ['steps', 'request', 'editable', 'events', 'groups', 'linkedRequests', 'icons'],
  components: {
    Multiselect
  },
  watch: {
    steps: (value) => {
      this.steps = value
    }
  }
}

</script>

<style scoped lang="scss">

  $active: #337ab7;
  $active_title: #4183c4;
  $border_color: #ddd;
  $content_width: 65%;
  $z-index: 1;

  /* Inspired by Semantic UI - http://semantic-ui.com/elements/step.html */
  .addStep0 {
    display: flex;
    position: relative;
    align-items: center
  }
  .step {
    @extend .addStep0;
    flex: 1 0 auto;
    flex-wrap: wrap;
    flex-direction: row;
    background: white;
    padding-left: 1.5em;
    border-left: 1px solid $border_color;
    border-bottom: 1px solid $border_color;
  }

  .step-options {
    margin-right: 0;
  }

  .step-options button {
    display: list-item;
    margin: 10px;
  }
  
  .step-description {
    color: gray;
  }

  .active .step-description{
    color: white;
  }

  .pad {
    padding: 10px;
  }
  .step .content {
    width: $content_width;
    padding: 10px;
    input {
      margin-bottom: 5px;
    }
  }
  .clickable {
    cursor: pointer;
  }
  .control {
    @extend .clickable;
    border: none;
    background: none;
  }

  .add {
    @extend .control;
    color: green;
  }

  .remove {
    @extend .control;
    color: red;
  }

  .add-evaluate-fields {
    @extend .control;
    color: #5964ff;
  }

  .add-trammit-fields {
    @extend .control;
    color: #000000;
  }

  .step:first-child {
    border-left: 0px;
  }

  .step::after {
    position: absolute;
    z-index: $z-index;
    content: '';
    top: 50%;
    right: 0;
    border: medium none;
    background: white;
    width: 1.5em;
    height: 1.5em;
    border-style: solid;
    border-color: $border_color;
    border-width: 0 1px 1px 0;
    transform: translateY(-50%) translateX(50%) rotate(-45deg);
  }

  .step.active {
    background: $active;
    color: white !important;
  }
  .step.active .icon {
    color: $active_title;
  }
  .step.active::after {
    background: $active;
  }
  .step:last-child::after {
    display: none
  }
  .steps {
    display: flex;
    border: 1px solid $border_color;
    flex-wrap: wrap;
  }

  .step-resume {
    font-size: 0.85em;
    margin-top: 5px;
  }

  .icon {
    font-size: 3em;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px;
  }

  .title {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 0px;
  }

  .subtitle {
    margin-bottom: 0px;
  }

  .message {
    color: gray;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// Steps.vue?25dcedc8